import { useEffect, useRef, useState } from "react";
import { Send, Wifi, WifiOff } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import useCourseChat from "../../hooks/useCourseChat";
import ChatMessage from "../../components/ChatMessage";

export default function ChatTab({ courseId }) {
  const { user } = useAuth();
  const { messages, connected, error, send } = useCourseChat(courseId);
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const ok = await send(text);
    if (ok) setText("");
  };

  return (
    <div className="nb-card-static p-0 overflow-hidden">
      <div className="px-5 py-3 border-b-2 border-[var(--gold)] bg-[var(--paper-soft)] flex items-center justify-between">
        <div>
          <h3 className="font-display text-lg font-bold">Class chat</h3>
          <p className="text-xs text-[var(--gold-soft)]">Real-time messages with classmates and your instructor.</p>
        </div>
        <span data-testid="chat-status" className={`flex items-center gap-1.5 text-xs font-bold ${connected ? "text-[var(--gold-bright)]" : "text-[var(--muted-text)]"}`}>
          {connected ? (<><Wifi className="w-3.5 h-3.5" /> live</>) : (<><WifiOff className="w-3.5 h-3.5" /> reconnecting…</>)}
        </span>
      </div>
      <div data-testid="chat-messages" className="h-[450px] overflow-y-auto p-5 space-y-3 bg-[var(--paper)]">
        {messages.length === 0 && (
          <p className="text-sm text-[var(--muted-text)] text-center mt-12">Be the first to say hi 👋</p>
        )}
        {messages.map((m) => (
          <ChatMessage key={m.id} message={m} isMine={m.user_id === user.id} />
        ))}
        <div ref={bottomRef} />
      </div>
      <form onSubmit={onSubmit} className="border-t-2 border-[var(--gold)] p-4 flex gap-2 bg-[var(--paper)]">
        <input
          data-testid="chat-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="nb-input flex-1"
          placeholder="Type a message..."
        />
        <button data-testid="chat-send-btn" disabled={!text.trim()} className="nb-btn nb-btn-yellow flex items-center gap-2 px-5">
          <Send className="w-4 h-4" /> Send
        </button>
      </form>
      {error && <div className="text-sm text-red-400 px-5 pb-3">{error}</div>}
    </div>
  );
}
